/* eslint quotes: 0*/
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { defineMessages } from 'react-intl';
import { decorateIntlMessages } from '../common/rosetta_formatted_message';
import classNames from 'classnames';
import SearchInput from '../search/search_input';
import { SVGs } from '../common/fa_icons';
import {pickBy, get, identity} from 'lodash';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';

/*
 * `/shop` is only on the US edition so it's fine to
 * hardcode this here for now.
 */
const SHOPPING_SEARCH_PATH = '/en-us/shop';

const messages = decorateIntlMessages(__filename, defineMessages({
  'placeholder': {
    id: 'placeholder',
    description: 'Placeholder text for the shopping search box.',
    defaultMessage: 'Search'
  }
}));

export default class ShoppingSearch extends Component {
  constructor(props, context) {
    super(props, context);
    const { q } = this.context.location.query;

    this.state = {
      is_active: false,
      query: q
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const { q } = this.context.location.query;
    const nextQ = get(nextContext, 'location.query.q');

    if (q !== nextQ) {
      this.setState({
        query: nextQ
      });
    }
  }

  toggleIsActive = () =>
    this.setState({ is_active: !this.state.is_active });

  handleChange = (event) =>
    this.setState({ query: event.currentTarget.value });

  handleClose = () => {
    this.toggleIsActive();
    this.setState({ query: '' });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    if (this.state.query) {
      this.context.router.push({
        pathname: SHOPPING_SEARCH_PATH,
        method: 'GET',
        query: pickBy({
          q: this.state.query
        }, identity)
      });
    }
  };

  render() {
    const { is_active, query } = this.state;
    const searchClass = classNames('shopping-search', { active: is_active });
    const searchContainerClass = classNames('search-container');
    const { resultCount, searchTerm } = this.props;

    return (
      <div className={searchClass}>
        <div className={searchContainerClass}>
          {resultCount > 0 &&
            <div className="products-count">
              <RosettaFormattedMessage parentFilename={__filename}
                id="product_count"
                description="Count of products found on product list pages"
                defaultMessage={`{resultCount, plural,
                      one   {1 product}
                      other {# products}
                    }`}
                values={{ resultCount }}
              />
              {searchTerm &&
                <span className="search-term">
                  <RosettaFormattedMessage parentFilename={__filename}
                    id="search_term"
                    description="Product search term on product list pages"
                    defaultMessage={`for "{searchTerm}"`}
                    values={{ searchTerm }}
                  />
                </span>
              }
            </div>
          }
          <form action={SHOPPING_SEARCH_PATH} method="GET" onSubmit={this.handleSubmit}>
            <SearchInput
              id="product_list_search"
              value={query}
              placeholderMessage={messages.placeholder}
              handleChange={this.handleChange}
            />
          </form>
          <div className="search-cta" tabIndex="0" role="button" onClick={this.toggleIsActive} onKeyPress={this.toggleIsActive}>
            <RosettaFormattedMessage parentFilename={__filename}
              id="placeholder"
              description="Placeholder text for the shopping search box."
              defaultMessage="Search"
            />
          </div>
          <div className="fa fa-search" tabIndex="0" role="button" aria-label="search enter" onClick={this.toggleIsActive} onKeyPress={this.toggleIsActive}
            dangerouslySetInnerHTML={{ __html: SVGs.search }}
          />
          <span className="search-close" tabIndex="0" role="button" onClick={this.handleClose} onKeyPress={this.handleClose} aria-label="exit search"/>
        </div>
      </div>
    );
  }
}

ShoppingSearch.propTypes = {
  resultCount: PropTypes.number,
  searchTerm: PropTypes.string
};

ShoppingSearch.contextTypes = {
  location: PropTypes.object,
  router: PropTypes.object
};
